import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';

import WidgetOfficeHeader from '../../components/WidgetOfficeHeader';
import OfficeReview from './OfficeReview';
import OfficeReviewsPage from './OfficeReviewsPage';

export const OFFICE_REVIEWS_PAGE_QUERY = gql`
  query OfficeReviewsPage($id: ID!) {
    office(id: $id) {
      id
      practice {
        id
        display
      }
      reviewsEnabled
      localmedRating: currentRating(serviceType: LOCALMED) {
        ...OfficeReviewsPageRating
      }
      facebookRating: currentRating(serviceType: FACEBOOK) {
        ...OfficeReviewsPageRating
      }
      googleRating: currentRating(serviceType: GOOGLE) {
        ...OfficeReviewsPageRating
      }
      yelpRating: currentRating(serviceType: YELP) {
        ...OfficeReviewsPageRating
      }
      ...${WidgetOfficeHeader.fragment.name}
      partnerReviews(perPage: 30) {
        nodes {
          id
          ...${OfficeReview.fragment.name}
        }
      }
    }
  }
  fragment OfficeReviewsPageRating on Rating {
    rating
    reviewCount
    serviceType
  }
  ${WidgetOfficeHeader.fragment.query}
  ${OfficeReview.fragment.query}
`;

const OfficeReviewsPageWithData = graphql(OFFICE_REVIEWS_PAGE_QUERY, {
  options({ match: { params } }) {
    return { variables: params };
  },
})(OfficeReviewsPage);

OfficeReviewsPageWithData.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default OfficeReviewsPageWithData;
